import { Typography } from "@mui/material";
import Grid from '@mui/material/Grid';
import { OrderWithItems } from 'common-models';
import { FC, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageIsLoading from "../PageIsLoading";

type PaymentCompletedViewProps = {
    order: OrderWithItems,
}

const PaymentCompletedView: FC<PaymentCompletedViewProps> = ({ order }) => {
    const nav = useNavigate();

    useEffect(() => {
        if (order && order.currentState === 'Completed') {
            setTimeout(() => nav({ pathname: `/orders/${order.id}` }), 5000);
        }
    }, [nav, order])

    return (
        <>
            {
                order === undefined ? (
                    <PageIsLoading />
                ) : (
                    <Grid container >
                        <Grid container>
                            <Typography variant="h1">Tack!</Typography>
                        </Grid>
                        <Grid container>
                            Din order är nu betald. Du kommer strax att flyttas till din ordersida där du kan ladda hem
                            bilderna. Om den inte laddas automatiskt, <Link to={`/orders/${order.id}`}>klicka här för att ladda den</Link>.
                        </Grid>
                    </Grid>

                )
            }
        </>
    );
    // }
};

export { PaymentCompletedView };
